export default "__VITE_ASSET__BmGHG9U4__"